'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class = require('common/utils/class');

var _messages = require('common/messages');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * BaseObject
 */

function BaseObject(properties) {
    if (properties) {
        this.setProperties(properties);
    }
}

Object.assign(BaseObject.prototype, {

    /**
     * Sets properties on the object, and broadcasts a change
     * notification if the object has changed.
     */

    setProperties: function setProperties(properties) {
        Object.assign(this, properties);

        // TODO - need to diff properties here to see if anything has actually changed (CC)
        if (this.notifier) {
            this.notifier.notify(_messages.ChangeMessage.create(this));
        }
    },


    /**
     * Sets one property on the object.
     * @deprecated use setProperties() instead
     */

    set: function set(keypath, value) {
        console.warn('DEPRECATED: calling set() on object. Use setProperties instead');
        this.setProperties(_defineProperty({}, keypath, value));
    }
});

BaseObject.extend = _class.extend;
BaseObject.create = _class.create;

exports['default'] = BaseObject;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/object/base.js
 ** module id = 580
 ** module chunks = 0
 **/